import { lazy } from "react";

// project imports
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

const FeeHead = Loadable(lazy(() => import("views/mastersetup/fee/Main")));
const FeeMapping = Loadable(lazy(() => import("views/mastersetup/fee/Main")));
const DownloadReceipt = Loadable(lazy(() => import('views/mastersetup/fee/downloadReceipt/index')));

const roles = ['ROLE_ADMIN', 'ROLE_COLLEGE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COLLEGE_SUB_ADMIN'];

const FeeRoutes = {
    path: "/",
    element: (
        <AuthGuard roles={roles}>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: "/fee-head",
            element: <FeeHead />,
        },
        {
            path: "/fee-mappings",
            element: <FeeMapping />,
        },
        {
            path: '/download/receipt',
            element: <DownloadReceipt />
        }
    ],
};

export default FeeRoutes;
